import styled from '@emotion/styled';
import { Table } from 'components/molecules/Table';
import { colors } from 'theme/colors';

export const StyledTable = styled(Table)`
  td {
    padding: 10px 12px;
  }
  td a {
    color: ${colors.green600};
  }
`;
